import { Record } from 'immutable';

export default Record({
  '@context': 'http://schema.org',
  '@type': 'GeoCoordinates',
  'latitude': null,
  'longitude': null,
});
